import { render } from "./children-multiselect.vue?vue&type=template&id=5570be8e&scoped=true"
import script from "./children-multiselect.vue?vue&type=script&lang=js"
export * from "./children-multiselect.vue?vue&type=script&lang=js"

import "./children-multiselect.vue?vue&type=style&index=0&id=5570be8e&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5570be8e"]])

export default __exports__